import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ICreateClientServiceRequest, ICreateServiceRequest, IService, IServiceDetailsResponse, IUpdateClientServiceRequest, IUpdateServiceRequest, IUpdateServiceStatusRequest, IUpdateServiceStatusResponse } from '../models/service';
import { IBaseGetByDeviceRequest, IPagedResults } from 'src/app/core/models/base';

@Injectable({
    providedIn: 'root'
})
export class DeviceServiceService {

    constructor(private http: HttpClient) { }

    createDeviceService(request: ICreateServiceRequest) {
        return this.http.post<IService>(
            `${environment.baseUrl}/v1/services/createService`,
            request
        )
    }

    createClientService(request: ICreateClientServiceRequest) {
        return this.http.post<IService>(
            `${environment.baseUrl}/v1/services/createClientService`,
            request
        )
    }

    getServiceById(id: string){
        return this.http.get<IService>(
          `${environment.baseUrl}/v1/services/getService/${id}`
        )
    }

    getServicesByDevice(request: IBaseGetByDeviceRequest){
        return this.http.get<IPagedResults<IService[]>>(
            `${environment.baseUrl}/v1/services/searchServicesByDevice/${request.deviceId}`
        )
    }

    updateDeviceService(request: IUpdateServiceRequest){
        return this.http.put<IService>(
            `${environment.baseUrl}/v1/services/updateService/${request.id}`,
            request
        )
    }

    updateClientDeviceService(request: IUpdateClientServiceRequest){
        return this.http.put<IService>(
            `${environment.baseUrl}/v1/services/updateClientService/${request.id}`,
            request
        )
    }

    updateDeviceServiceStatus(request: IUpdateServiceStatusRequest){
        return this.http.put<IService>(
            `${environment.baseUrl}/v1/services/serviceStatusChange/${request.id}`,
            request
        )
    }

    deleteDeviceService(id :string){
        return this.http.delete(
            `${environment.baseUrl}/v1/services/deleteService/${id}`
        )
    }

    deleteClientService(id :string){
        return this.http.delete(
            `${environment.baseUrl}/v1/services/deleteClientService/${id}`
        )
    }
}
